module.exports = __webpack_public_path__ + "img/胡老师-1.db83791b.png";